import StatusTag from "../StatusTag/StatusTag";
import { IUserDetails } from "../../interface/UserDetail";
import { capitalizeFirstLetter } from "../../utils/utils";
import { UserDataWrapper } from "./InfoStyled";

const DataItem = ({ label, item }: { label: string; item: any }) => {
  return (
    <div className="data-item">
      <span className="label">{label}</span>
      <span className="item">{item}</span>
    </div>
  );
};

const CustomerData = ({ data }: { data: IUserDetails }) => {
  const items = data?.manufacturing_file_types
    ?.map((type) => {
      return type.name;
    })
    ?.join(",");
  return (
    <UserDataWrapper>
      <DataItem
        label={`Customer Name`}
        item={capitalizeFirstLetter(data.name)}
      />
      <DataItem label="Account Number" item={data.customer_id} />
      <DataItem label="Test Data Available" item={items} />

      <DataItem label="Status" item={<StatusTag content={data.status} />} />
    </UserDataWrapper>
  );
};

export default CustomerData;
